export default "__VITE_ASSET__BObJo4d0__"